import type { VariableConfig } from '@/types/edit/VariableConfig.ts';
import { programmingLanguageOptions } from '@/types/ProgrammingLanguage.ts';

export const PROGRAMMING_LANGUAGE_VARIABLE_ID = '98d8feff-4acf-4f05-92e7-e07b04250dc1';
export const PROGRAMMING_LANGUAGE_OPTIONS_VARIABLE_ID = '7033b069-9c06-41c9-8177-2a7b3c6c669d';
export const FORMATTING_CONFIG_VARIABLE_ID = '5d847ecf-2968-48f3-8549-0752220a59f9';

const PROGRAMMING_LANGUAGE_VARIABLE_KEY = 'PROGRAMMING_LANGUAGE';
const PROGRAMMING_LANGUAGE_OPTIONS_VARIABLE_KEY = 'PROGRAMMING_LANGUAGE_OPTIONS';
const FORMATTING_CONFIG_VARIABLE_KEY = 'FORMATTING_CONFIG';

export const SCREEN_CAPTURE_VARIABLE_KEY = 'SCREEN_CAPTURE';

export const DefaultVariableConfigs: Record<VariableConfig['id'], VariableConfig> = {
    [PROGRAMMING_LANGUAGE_VARIABLE_ID]: {
        id: PROGRAMMING_LANGUAGE_VARIABLE_ID,
        key: PROGRAMMING_LANGUAGE_VARIABLE_KEY,
        type: 'DEFAULT',
        valueType: 'string',
        value: 'Python3',
        description: undefined,
        editable: false,
    },
    [PROGRAMMING_LANGUAGE_OPTIONS_VARIABLE_ID]: {
        id: PROGRAMMING_LANGUAGE_OPTIONS_VARIABLE_ID,
        key: PROGRAMMING_LANGUAGE_OPTIONS_VARIABLE_KEY,
        type: 'DEFAULT',
        valueType: 'array',
        value: programmingLanguageOptions,
        description: undefined,
        editable: false,
    },
    [FORMATTING_CONFIG_VARIABLE_ID]: {
        id: FORMATTING_CONFIG_VARIABLE_ID,
        key: FORMATTING_CONFIG_VARIABLE_KEY,
        value: `root = true

[*]
charset = utf-8
end_of_line = lf
indent_size = 4
indent_style = space
insert_final_newline = true
trim_trailing_whitespace = true`,
        type: 'DEFAULT',
        valueType: 'string',
        description: 'A standardized formatting config for code output.',
        editable: false,
    },
};
